import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../shared/icon/icon.component';
import { FlightRouteContent, isInternational } from '../flight-route.model';

/** Landing page hero: destination photo (or brand gradient), H1 and the route drawn as a flight path. */
@Component({
  selector: 'app-flight-route-hero',
  imports: [RouterLink, IconComponent],
  templateUrl: './flight-route-hero.component.html',
  styleUrls: ['./flight-route-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightRouteHeroComponent {
  readonly route = input.required<FlightRouteContent>();
  readonly international = computed(() => isInternational(this.route()));
}
